export const permissionsMap = {
  users: '/users',
  company_manager: '/company-manager',
  'earning-managers': '/earning-managers',
  'forms-manager': '/forms-manager',
  country_manager: '/country_manager',
   state_manager: '/state_manager',
  city_manager: '/city_manager',
  notification_manager: '/notification_manager',
  reports: '/report/registered_companies',
  'static-page-management': '/static-page-management',
  subscription_manager: '/subscription_manager',
  support_manager: '/support_manager',
  'banner-management': '/banner-management',
  settings: '/settings',
  faqs: '/faqs',
  'category-subcategory-manager': '/category-subcategory-manager'
}
